import { types } from 'mobx-state-tree';

export const ExperienceModel = types.model('ExperienceModel', {
  id: types.maybe(types.number),
  title: types.maybeNull(types.string),
  position_title: types.maybeNull(types.string),
  industries: types.array(types.frozen()),
  job_functions: types.array(types.frozen()),
  location: types.maybeNull(types.string),
  start: types.maybeNull(types.string),
  finish: types.maybeNull(types.string),
  is_current_job: types.maybeNull(types.boolean),
  main_theme_id: types.maybeNull(types.number),
  sub_theme_id: types.maybeNull(types.number),
  focuses: types.maybeNull(types.array(types.frozen()))
});
